import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportSessionUsageModal } from './report-session-usage.modal';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { PodNgCoreModule, ValidationMessagesModule, ValidationClassDirectiveModule } from 'pod-ng-core';

@NgModule({
    declarations: [
        ReportSessionUsageModal
    ],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule.forChild(),
        PodNgCoreModule.forChild(),
        ValidationMessagesModule,
        ValidationClassDirectiveModule
    ],
    exports: [
        ReportSessionUsageModal
    ],
    providers: []
})
export class ReportSessionUsageModalModule {}
